<p>encadreurs-view works!</p>
